import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarItbiViewDs } from "../../DataSources";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import Memoria from "../../Memoria";
import { imprimirDam, imprimirAlvara, abrirDetalheFuncao, imprimirDamFunction } from "../../lancamentosUtils";
import notify from "devextreme/ui/notify";

const localStorageKey = "cadastroItbiGridState";

export default class ItbiBox extends Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.itbiAbrirDetalhe = this.itbiAbrirDetalhe.bind(this);
    this.itbiImprimirAlvara = this.itbiImprimirAlvara.bind(this);
    this.itbiImprimirDam = this.itbiImprimirDam.bind(this);

    this.statusDataSource = [
      { id: 0, descricao: "GERADO" },
      { id: 1, descricao: "PAGO/DISPENSADO" },
      { id: 2, descricao: "EMITIDO" },
      { id: 3, descricao: "CANCELADO" },
      { id: 4, descricao: "SUSPENSO" },
      { id: 5, descricao: "CASSADO" },
    ];

    this.posicaoFiscalDataSource = [
      { id: 0, descricao: "TRIBUTAVEL" },
      { id: 1, descricao: "IMUNE" },
      { id: 2, descricao: "ISENTO" },
    ];
  }

  itbiAbrirDetalhe(history, data) {

    if (data.origem === "H") {
      notify("Registro de histórico não permite operação");
      return;
    }

    if (data.lancamentoId == undefined){
      notify("ITBI de migração não pode acessar detalhe de lançamento.");
      return;
    }

    abrirDetalheFuncao(this.props.history, data.lancamentoSeq);

  }

  itbiImprimirDam(data) {

    if (data.status > 0 || data.posicaoFiscal != 0) {
      notify("Registro não permite impressão de DAM");
      return;
    }

    imprimirDamFunction(data.prefeituraId, data.lancamentoId, data.chaveLancamento);
  }

  itbiImprimirAlvara(data) {

    if ((data.status == 0 && data.posicaoFiscal == 0) || data.status == 3) {
      notify("Registro não permite impressão");
      return;
    }

    imprimirAlvara("LINKDIRETO_ITBI", data.id);

  }

  filtrar(e) {
    let filtro = this.state.filtro;
    console.log(this.state.filtro);

    let filtroCorrente = [];

    if (
      filtro.sequencial !== null &&
      filtro.sequencial !== undefined &&
      filtro.sequencial !== ""
    ) {
      filtroCorrente.push(["lancamentoSeq", "=", filtro.sequencial]);
    }
    if (filtro.ano !== null && filtro.ano !== undefined && filtro.ano !== "") {
      filtroCorrente.push(["exercicio", "=", filtro.ano]);
    }
    if (
      filtro.dataInicial !== null &&
      filtro.dataInicial !== undefined &&
      filtro.dataInicial !== ""
    ) {
      var dataInicial = new Date(filtro.dataInicial.setHours(0, 0, 0, 0));
      filtroCorrente.push(["data", ">=", dataInicial]);
    }
    if (
      filtro.dataFinal !== null &&
      filtro.dataFinal !== undefined &&
      filtro.dataFinal !== ""
    ) {
      var dataFinal = new Date(filtro.dataFinal.setHours(23, 59, 59, 999));
      filtroCorrente.push(["data", "<=", dataFinal]);
    }
    if (
      filtro.vendedorSequencial !== null &&
      filtro.vendedorSequencial !== undefined &&
      filtro.vendedorSequencial !== ""
    ) {
      filtroCorrente.push([
        "vendedorSeq",
        "=",
        filtro.vendedorSequencial,
      ]);
    }
    if (
      filtro.vendedorNome !== null &&
      filtro.vendedorNome !== undefined &&
      filtro.vendedorNome !== ""
    ) {
      filtroCorrente.push([
        "vendedor",
        "contains",
        filtro.vendedorNome,
      ]);
    }
    if (
      filtro.compradorSequencial !== null &&
      filtro.compradorSequencial !== undefined &&
      filtro.compradorSequencial !== ""
    ) {
      filtroCorrente.push([
        "compradorSeq",
        "=",
        filtro.compradorSequencial,
      ]);
    }
    if (
      filtro.compradorNome !== null &&
      filtro.compradorNome !== undefined &&
      filtro.compradorNome !== ""
    ) {
      filtroCorrente.push([
        "comprador",
        "contains",
        filtro.compradorNome,
      ]);
    }
    if (
      filtro.imovelSequencial !== null &&
      filtro.imovelSequencial !== undefined &&
      filtro.imovelSequencial !== ""
    ) {
      filtroCorrente.push(["imovelSeq", "=", filtro.imovelSequencial]);
    }
    if (
      filtro.numero !== null &&
      filtro.numero !== undefined &&
      filtro.numero !== ""
    ) {
      filtroCorrente.push(["numero", "=", filtro.numero]);
    }
    if (
      filtro.valorInicial !== null &&
      filtro.valorInicial !== undefined &&
      filtro.valorInicial !== ""
    ) {
      filtroCorrente.push(["imposto", ">=", filtro.valorInicial]);
    }
    if (
      filtro.valorFinal !== null &&
      filtro.valorFinal !== undefined &&
      filtro.valorFinal !== ""
    ) {
      filtroCorrente.push(["imposto", "<=", filtro.valorFinal]);
    }

    console.log("filtro corrente", filtroCorrente);
    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  onAtualizandoRow(e) {

    e.cancel = true;

    if (e.data.lancamentoId == undefined) {
      notify("Registro migrado, edição não permitida.", "error");
      return;
    }

    if (e.data.status != 0 || e.data.posicaoFiscal != 0) {
      notify("Status e/ou posição fiscal do registro não permite edição, por favor verifique!", "error");
      return;
    }

    this.props.history.push("itbi/editar/" + e.data.lancamentoSeq);
  }

  componentDidMount() {
    Memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form
              id="frmPesquisa"
              formData={this.state.filtro}
              colCount={7}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField="sequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Código do ITBI" />
              </SimpleItem>
              <SimpleItem
                dataField="ano"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Ano" />
              </SimpleItem>
              <SimpleItem
                dataField="numero"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Número" />
              </SimpleItem>
              <SimpleItem
                dataField="dataInicial"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField="dataFinal"
                dataType="date"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data Final" />
              </SimpleItem>
              <SimpleItem
                dataField="valorInicial"
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                cssClass={"txtFrmCpbsNumerico"}
              >
                <Label text="Valor Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField="valorFinal"
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                cssClass={"txtFrmCpbsNumerico"}
              >
                <Label text="Valor Final" />
              </SimpleItem>
              <SimpleItem
                dataField="vendedorSequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Cód. Transmitente" />
              </SimpleItem>
              <SimpleItem dataField="vendedorNome" colSpan={2}>
                <Label text="Nome do Transmitente" />
              </SimpleItem>

              <SimpleItem
                dataField="compradorSequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Cód. Adquirente" />
              </SimpleItem>
              <SimpleItem dataField="compradorNome" colSpan={2}>
                <Label text="Nome do Adquirente" />
              </SimpleItem>
              <SimpleItem
                dataField="imovelSequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Código do Imóvel" />
              </SimpleItem>


            </Form>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <br />
          <PaginaToolbar titulo="ITBI" novoCb={this.novoRegistro.bind(this)}>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarItbiViewDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <Editing
                allowDeleting={true}
                allowUpdating={true}
                useIcons={true}
              />

              <Column type="buttons" fixed={true} fixedPosition={"left"} buttons={
                ["edit", {

                  hint: 'DAM',
                  icon: 'money',
                  visible: !this.onSelecionado,
                  onClick: e => this.itbiImprimirDam(e.row.data)
                },
                  {
                    hint: 'Guia ITBI',
                    icon: 'exportpdf',
                    visible: !this.onSelecionado,
                    onClick: e => this.itbiImprimirAlvara(e.row.data)
                  },
                  {
                    hint: 'Info. Lançamento',
                    icon: 'more',
                    visible: !this.onSelecionado,
                    onClick: e => this.itbiAbrirDetalhe(this.props.history, e.row.data)
                  }, {
                    icon: 'repeat',
                    visible: this.onSelecionado ? true : false,
                    onClick: this.onSelecionado
                  }]} />


              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column
                dataField={"data"}
                dataType={"date"}
                caption={"Data"}
                width={110}
              />

              <Column
                dataField={"exercicio"}
                caption={"Ano"}
                sortOrder="desc"
                sortIndex={1}
                width={80}
              />
              <Column
                dataField={"numero"}
                caption={"Número"}
                sortOrder="desc"
                sortIndex={2}
                width={100}
              />

              <Column
                dataField={"lancamentoSeq"}
                caption={"Lançamento"}
                width={120}
              />

              <Column
                dataField={"dam"}
                caption={"DAM"}
                width={110}
              />

              <Column
                dataField={"status"}
                caption={"Status"}
                width={150}
              >
                <Lookup dataSource={this.statusDataSource} valueExpr={"id"} displayExpr={"descricao"} />
              </Column>
              <Column
                dataField={"posicaoFiscal"}
                caption={"PosicaoFiscal"}
                width={110}
              >
                <Lookup dataSource={this.posicaoFiscalDataSource} valueExpr={"id"} displayExpr={"descricao"} />
              </Column>
              <Column
                dataField={"imovelSeq"}
                caption={"Imóvel"}
                width={80}
                alignment={"center"}
              />
              <Column
                dataField={"vendedorSeq"}
                caption={"Cod. Transmitente"}
                visible={false}
              />
              <Column
                dataField={"vendedor"}
                caption={"Transmitente"}
              />
              <Column
                dataField={"compradorSeq"}
                caption={"Cod. Adquirente"}
                visible={false}
              />
              <Column
                dataField={"comprador"}
                caption={"Adquirente"}
              />
              <Column
                dataField={"imposto"}
                caption={"Valor"}
                format={{ type: "fixedPoint", precision: 2 }}
                width={90}
              />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("itbi/novo");
  }
}
